<template>
  <section class="nav-sub mx-auto container max-w-5xl px-5 md:px-4 py-4">
    <div class="grid grid-cols-12 rounded shadow-xs p-8">
      <div class="col-span-12 md:col-span-4 mb-8 md:mb-0 relative">
        <h3 class="text-lg">
          {{ listFirst.columnTitle }}
        </h3>
        <kf-list
          :class="{ 'mb-8': totalItems }"
          :items="listFirstToDisplay"
        />
        <kf-button
          v-if="listFirst.items && listFirst.items.length > maxItems"
          class="btn-show text-black"
          @click="showLessItems = !showLessItems"
        >
          {{ showLessItems === true ? listFirst.labelMoreSubjects : listFirst.labelLessSubjects }}
        </kf-button>
      </div>
      <div class="col-span-12 md:col-span-4 mb-8 md:mb-0 relative">
        <h3 class="text-lg">
          {{ listSecond.columnTitle }}
        </h3>
        <kf-list
          :class="{ 'mb-8': totalItems }"
          :items="listSecondToDisplay"
        />
        <kf-button
          v-if="listSecond.items && listSecond.items.length > maxItems"
          class="btn-show text-black"
          @click="showLessItems = !showLessItems"
        >
          {{ showLessItems === true ? listSecond.labelMoreSubjects : listSecond.labelLessSubjects }}
        </kf-button>
      </div>
      <div class="col-span-12 md:col-span-4 relative">
        <h3 class="text-lg">
          {{ listThird.columnTitle }}
        </h3>
        <kf-list
          :class="{ 'mb-8': totalItems }"
          :items="listThirdToDisplay"
        />
        <kf-button
          v-if="listThird.items && listThird.items.length > maxItems"
          class="btn-show text-black"
          @click="showLessItems = !showLessItems"
        >
          {{ showLessItems === true ? listThird.labelMoreSubjects : listThird.labelLessSubjects }}
        </kf-button>
      </div>
    </div>
  </section>
</template>

<script>
import KfButton from '@/components/base/button/Button.vue';
import KfList from '@/components/base/list/List.vue';

export default {
  name: 'NavigationSub',
  components: {
    KfList,
    KfButton,
  },
  props: {
    listFirst: {
      type: Object,
      default: null,
    },
    listSecond: {
      type: Object,
      default: null,
    },
    listThird: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      maxItems: 5,
      showLessItems: true,
    };
  },
  computed: {
    listFirstToDisplay() {
      if (this.showLessItems && this.listFirst.items) {
        return this.listFirst.items.slice(0, this.maxItems);
      } else {
        return this.listFirst.items;
      }
    },
    listSecondToDisplay() {
      if (this.showLessItems && this.listSecond.items) {
        return this.listSecond.items.slice(0, this.maxItems);
      } else {
        return this.listSecond.items;
      }
    },
    listThirdToDisplay() {
      if (this.showLessItems && this.listThird.items) {
        return this.listThird.items.slice(0, this.maxItems);
      } else {
        return this.listThird.items;
      }
    },
    totalItems() {
      if (
        (this.listFirst.items && this.listFirst.items.length > this.maxItems) ||
        (this.listSecond.items && this.listSecond.items.length > this.maxItems) ||
        (this.listThird.items && this.listThird.items.length > this.maxItems)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="postcss" scoped>
.btn-show {
  @apply mt-2 underline absolute bottom-0;
  font-size: 15px;

  &:hover {
    @apply no-underline;
  }
}
</style>
